import { Component, OnInit } from '@angular/core';
import { select, select$ } from '@angular-redux/store';
import { Observable } from 'rxjs/Observable';
import { ISessionState } from '../../../app-states/modules/session/ISessionState';
import { AuthenticationService } from '../../security/services/index';
import { clearState } from '../../../app-states/store/local-storage';

@Component({
  selector: 'mc-user-status',
  templateUrl: './user-status.component.html',
  styleUrls: ['./user-status.component.scss']
})
export class UserStatusComponent implements OnInit {
  @select(['sessionState']) session$: Observable<ISessionState>;
  session: ISessionState;
  constructor(private sessionService: AuthenticationService,) {

  }

  logout() {
    this.sessionService.logOut().subscribe((authenticated) => {
      clearState();
      location.reload();
    });
  }

  ngOnInit() {
    this.session$.subscribe((sessionChange) => {
      this.session = sessionChange;
    });
  }
}



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/core/template/user-status/user-status.component.ts